import { useRouter } from '@tanstack/react-router';
import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';
import { generatePath } from '@/services/router/generate-path';

const INTEGRATIONS_INDEX_PATH = '/workspaces/:workspaceId/integrations';

/** Where Cancel returns to — Ember handed off to the Connections tab. */
export function useIntegrationsOverviewHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/integrations/all/overview', { workspaceId });
}

export function useMParticleBreadcrumbs(workspaceId: string): void {
  const router = useRouter();

  useRegisterBreadcrumbs([
    {
      id: 'integrations',
      text: 'Integrations',
      href: generatePath(INTEGRATIONS_INDEX_PATH, { workspaceId }),
    },
    {
      id: 'integrations_mparticle',
      text: 'mParticle',
      href: router.buildLocation({
        to: '/workspaces/$workspaceId/integrations/mparticle_out',
        params: { workspaceId },
      }).href,
    },
  ]);
}
